import { UserAgent } from 'express-useragent'

const shouldLogF = () => {
  const params = new URLSearchParams(window.location.search)
  return params.get('enableLogging')
}

const shouldLog = shouldLogF()

const consoleLog = (...args) => {
  if (shouldLog) {
    console.log(...args)
  }
}

const hasChromeRuntime = !!window.chrome

let userAgent

function getUserAgent() {
  if (!userAgent) {
    userAgent = new UserAgent().parse(navigator.userAgent)
    userAgent.isSafari = userAgent.isSafari || userAgent.isiPhone
  }
  return userAgent
}

function isMobile() {
  const userAgent = getUserAgent()
  return userAgent.isMobile && !(isIPad() || userAgent.isAndroidTablet)
}

function isTabletOrMobile() {
  return isTablet() || isMobile()
}

function isTablet() {
  const userAgent = getUserAgent()
  const result = userAgent.isiPad || userAgent.isAndroidTablet || userAgent.isTablet
  if (!result && userAgent.isSafari && window.innerWidth < window.innerHeight) {
    return true
  }
  return result
}

function isApple() {
  const ua = getUserAgent()
  return ua.isMac || ua.isIPhone
}

function isIOS() {
  return (isMobile() || isIPad()) && getUserAgent().isSafari
}

function isSafari() {
  if (window.chrome) return false
  return getUserAgent().isSafari
}

function isWindows() {
  const userAgent = getUserAgent()
  return userAgent.isWindows || userAgent.os?.startsWith('Windows')
}

function isChrome() {
  return getUserAgent().isChrome || hasChromeRuntime
}

function isFirefoxDesktop() {
  return getUserAgent().isFirefox && isDesktop()
}

function isDesktop() {
  return getUserAgent().isDesktop && !isIPad()
}

function isEdge(){
  return getUserAgent().isEdge
}

function isIPad() {
  const userAgent = getUserAgent()
  return (navigator.platform.startsWith('Mac') && navigator.maxTouchPoints > 2) || userAgent.isiPad
}

function hasSoftKeyboard() {
  const userAgent = getUserAgent()
  return userAgent.isMobile || userAgent.isiPad || userAgent.isAndroidTablet
}

function isAndroid() {
  return userAgent.isAndroid
}

export {
  hasSoftKeyboard,
  isAndroid,
  isTabletOrMobile,
  isTablet,
  isIPad,
  isApple,
  isMobile,
  isIOS,
  isSafari,
  isChrome,
  isDesktop,
  isFirefoxDesktop,
  isEdge,
  isWindows,
  shouldLog,
  consoleLog
}
